import { useCallback, useEffect, useState } from "react";
import styled from 'styled-components';
import { notification } from 'antd';
import { Chart } from "react-chartjs-2";
import {
	Chart as ChartJS,
	LinearScale,
	CategoryScale,
	BarElement,
	PointElement,
	LineElement,
	Legend,
	Tooltip,
	BarController,
	LineController,
	Title
} from "chart.js";

// services
import * as UniverseService from '../../../../services/bb-api/universe';

ChartJS.register(
	LinearScale,
	CategoryScale,
	BarElement,
	PointElement,
	LineElement,
	BarController,
	LineController,
	Legend,
	Tooltip,
	Title
);

export const AgeGroupsDiagram: React.FC = () => {
	const [userData, setUserData] = useState<{ ageGroup: string, memberCount: number }[]>([]);

	const getData = useCallback(() => {
		try {
			UniverseService.getAgeDistribution(13).then(setUserData)
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 1 min
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	function generateLabels(): Array<string> {
		let labels: Array<string> = [];
		userData.forEach(element => {
			labels.push(element.ageGroup);
		});
		return labels;
	}

	function getMemberCount(): Array<number> {
		let memberCount: Array<number> = [];
		userData.forEach(ageGroup => {
			memberCount.push(ageGroup.memberCount);
		});
		return memberCount;
	}

	function getHighestMemberCount(userData: { ageGroup: string, memberCount: number }[]): number {
		let highestCount = 0;
		userData.forEach((ageGroup) => {
			if (ageGroup.memberCount > highestCount) {
				highestCount = ageGroup.memberCount;
			}
		});
		highestCount = Math.ceil(highestCount / 100) * 100;
		return highestCount;
	}

	const chartData = {
		labels: generateLabels(),
		datasets: [
			{
				data: getMemberCount(),
				backgroundColor: '#5a1158',
				borderRadius: 6,
				// borderSkipped: false,
			},
		],
	};

	const chartOptions: Record<string, any> = {
		plugins: {
			title: {
				display: true,
				text: 'Aldersfordeling',
				color: 'rgba(255, 255, 255, 0.55)',
				font: {
					size: 16,
				},
			},
			legend: {
				display: false,
				labels: {
					color: 'rgba(255, 255, 255, 0.55)',
					boxWidth: 0,
				},
			},
		},
		scales: {
			y: {
				display: true,
				position: 'left',
				min: 0,
				max: getHighestMemberCount(userData),
				ticks: {
					stepSize: 100,
					font: {
						size: 18,
					},
					autoSkip: true,
					maxTicksLimit: 11,
				},
				grid: {
					color: '#9CA3AF',
					drawBorder: false, // Hide the y-axis line (Chart.js version 3.X.X)
				},
				border: {
					display: false, // Hide the y-axis line (Chart.js version 4.X.X)
				},
			},
			x: {
				grid: {
					display: false,
				},
				ticks: {
					color: 'rgba(255, 255, 255, 0.55)',
				},
			}
		},
		maintainAspectRatio: false,
	};

	return (
		<StyledContainer className="age-groups-diagram">
			<div className="diagram">
				<Chart
					type='bar'
					data={chartData}
					options={chartOptions}
				/>
			</div>
		</StyledContainer>
	);
}

const StyledContainer = styled.div`
	margin: 1em;

	.diagram {
		width: 100%;
		height: 100%;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
		background-color: #1f2937;
		border-radius: 0.5em;
		padding: 2em;
	}
`
